import styled from '@olxui/core/dist/theme/styled';
import { LegendWrapper } from '~components/ServiceBookingPanel/BookingCalendar/BookingCalendar.components';
import { P4 } from '@olxui/core/dist/core/Typography';

export const StyledDotInformation = styled.div<{
    availableDates?: boolean;
    isSelectedDateInBlockedDates?: boolean;
}>`
    ${({ theme, isSelectedDateInBlockedDates, availableDates }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${theme.fontSizes[12]};
    width: ${theme.lineHeights[20]};
    height: ${theme.lineHeights[20]};
    margin-left: ${theme.space[20]};
    margin-right: ${theme.space[8]};
    border-radius: 100%;
    border: 1px solid ${theme.colors['background-brand-disabled']};
    background-color: ${
        isSelectedDateInBlockedDates
            ? theme.colors['background-brand-notification-success']
            : availableDates
            ? 'transparent'
            : theme.colors['background-brand-notification-error']
    }
`}
`;
export const StyledLegendWrapper = styled(LegendWrapper)`
    align-items: center;
    justify-content: center;
    margin-bottom: ${({ theme }) => theme.space[12]};
    flex-wrap: wrap;
`;

export const StyledLineInformation = styled.div`
    ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${theme.fontSizes[14]};
    width: ${theme.lineHeights[26]};
    height: ${theme.lineHeights[26]};
    margin-left: ${theme.space[20]};
    margin-right: ${theme.space[8]};
    border: none;
    text-decoration-line: line-through;
`}
`;

export const StyledContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledP4 = styled(P4)`
    ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: ${theme.fontWeights[500]};
    font-size: ${theme.fontSizes[12]};
    line-height: ${theme.lineHeights[12]};
    `}
`;
